import { render, staticRenderFns } from "./SignUpOTP.vue?vue&type=template&id=7a9cde10"
import script from "./SignUpOTP.vue?vue&type=script&lang=js"
export * from "./SignUpOTP.vue?vue&type=script&lang=js"
import style0 from "./SignUpOTP.vue?vue&type=style&index=0&id=7a9cde10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports